<template>
  <div>
    <div v-if="loading" class="text-muted py-4">
      {{ $t("LOADING") }}
    </div>
    <div v-else-if="error" class="text-warning py-4">
      {{ $t("PAGE.CAMPAIGN.FORM.CAMPAIGN_RECEIPT.MEMBERS.LOAD_ERROR_DETAIL") }}
    </div>
    <div v-else>
      <div class="table-responsive">
        <b-table
          :items="items"
          :fields="fields"
          :busy="busy"
          small
          head-variant="light"
          show-empty
          :empty-text="$t('PAGE.DEFAULT.TABLE.DATA_NOT_FOUND')"
        >
          <template #cell(created_at)="row">
            {{ formatDate(row.item.created_at) }}
          </template>
          <template #cell(point)="row">
            {{
              row.item.point != null && row.item.point !== ""
                ? row.item.point
                : "—"
            }}
          </template>
          <template #cell(remark)="row">
            {{ row.item.remark || "—" }}
          </template>
        </b-table>
      </div>
      <b-row class="justify-content-between mt-2">
        <b-col cols="12" md="4">
          <b-form-group
            :label="$t('PAGE.DEFAULT.TABLE.PER_PAGE')"
            label-cols="5"
            label-size="sm"
            class="mb-0"
          >
            <b-form-select
              :value="perPage"
              size="sm"
              :options="perPageOptions"
              @change="onPerPageSelect"
            />
          </b-form-group>
        </b-col>
        <b-col cols="12" md="8">
          <b-pagination
            :value="page"
            :total-rows="totalRows"
            :per-page="perPage"
            align="right"
            class="mb-0"
            @input="$emit('page-input', $event)"
          />
        </b-col>
      </b-row>
    </div>
  </div>
</template>

<script>
export default {
  name: "CampaignMemberPointHistoryBody",
  props: {
    loading: {
      type: Boolean,
      default: false
    },
    error: {
      type: Boolean,
      default: false
    },
    busy: {
      type: Boolean,
      default: false
    },
    items: {
      type: Array,
      default: () => []
    },
    page: {
      type: Number,
      default: 1
    },
    perPage: {
      type: Number,
      default: 25
    },
    totalRows: {
      type: Number,
      default: 0
    },
    perPageOptions: {
      type: Array,
      default: () => [25, 50, 100]
    }
  },
  computed: {
    fields() {
      return [
        {
          key: "created_at",
          label: this.$t("PAGE.CAMPAIGN.FORM.CAMPAIGN_RECEIPT.MEMBERS.COL_DATE")
        },
        {
          key: "receipt_type_name",
          label: this.$t(
            "PAGE.CAMPAIGN.FORM.CAMPAIGN_RECEIPT.MEMBERS.COL_RECEIPT_TYPE"
          )
        },
        {
          key: "approve_status_name",
          label: this.$t(
            "PAGE.CAMPAIGN.FORM.CAMPAIGN_RECEIPT.MEMBERS.COL_STATUS"
          )
        },
        {
          key: "point",
          label: this.$t(
            "PAGE.CAMPAIGN.FORM.CAMPAIGN_RECEIPT.MEMBERS.COL_POINT"
          )
        },
        {
          key: "verify_code",
          label: this.$t(
            "PAGE.CAMPAIGN.FORM.CAMPAIGN_RECEIPT.MEMBERS.COL_VERIFY_CODE_RECEIPT"
          )
        },
        {
          key: "remark",
          label: this.$t(
            "PAGE.CAMPAIGN.FORM.CAMPAIGN_RECEIPT.MEMBERS.COL_REMARK"
          )
        }
      ];
    }
  },
  methods: {
    formatDate(v) {
      if (!v) {
        return "—";
      }
      try {
        return new Date(v).toLocaleString();
      } catch (e) {
        return v;
      }
    },
    onPerPageSelect(v) {
      this.$emit("per-page-change", v);
    }
  }
};
</script>
